import { Box, Flex } from '@rebass/grid'
import * as firebase from 'firebase'
import * as moment from 'moment'
import * as R from 'ramda'
import * as React from 'react'
import { connect } from 'react-redux'
import { Text } from 'src/elements'
import { Dispatch, RootState } from 'src/store'
import { getDuration } from 'src/utils'
import styled, { css } from 'styled-components'
import Avatar from '../Avatar'
import Icon from '../Icon'
import DisplayBlock from './DisplayBlock'
import EditBlock from './EditBlock'

interface IConnectProps {
  replyId: string
  onLike?: () => void
  onReply?: () => void
  onEdit?: (text: string) => void
}
type IReplyProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch> &
  IConnectProps

const ReplyContainer = styled(Flex)`
  ${(props: { isActive?: boolean }) =>
    props.isActive &&
    css`
      &:before {
        content: '';
        width: 2px;
        background: #ff730e;
        right: 12px;
        position: relative;
        margin-right: -2px;
      }
    `};
`

class Reply extends React.Component<IReplyProps> {
  public state = {
    isEditing: false,
    text: this.props.reply ? this.props.reply.text : ''
  }
  public handleEditClick = () => {
    this.setState({ isEditing: true })
  }
  public handleConfirmClick = () => {
    if (this.props.onEdit) {
      this.props.onEdit(this.state.text)
    }
    this.setState({ isEditing: false })
  }
  public handleCancelClick = () => {
    this.setState({ isEditing: false })
  }
  public handleTextChange = (e: React.FormEvent<HTMLTextAreaElement>) => {
    this.setState({ text: e.currentTarget.value })
  }
  public componentDidMount = () => {
    this.props.onFetch()
  }
  public componentWillReceiveProps = (nextProps: IReplyProps) => {
    const { reply } = nextProps
    this.setState({ text: reply ? reply.text : `` })
  }
  public render() {
    const { reply, replier, onLike, isActive } = this.props
    const currentUser = firebase.auth().currentUser
    const likes = reply ? reply.reactions.like.length : 0
    const isLiked =
      reply &&
      currentUser !== null &&
      R.contains(currentUser.uid, reply.reactions.like)
    return (
      <ReplyContainer
        isActive={isActive}
        ref={ref => {
          if (ref && isActive) {
            ref.scrollIntoView({ behavior: 'smooth' })
          }
        }}
      >
        <Box alignSelf="flex-end" mr={2} pb={34}>
          <Avatar userId={reply ? reply.replierId : ''} />
        </Box>
        <Flex flexDirection="column" flex={1}>
          <Flex mb={1} justifyContent="space-between">
            <Box>
              <Text.LabelGray>{replier ? replier.fullName : ''}</Text.LabelGray>
            </Box>
            {currentUser &&
            reply &&
            currentUser.uid === reply.replierId &&
            !this.state.isEditing ? (
              <Box>
                <Icon type="edit" onClick={this.handleEditClick} />
              </Box>
            ) : null}
          </Flex>
          <Box mb={1}>
            {this.state.isEditing ? (
              <EditBlock
                onChange={this.handleTextChange}
                onConfirm={this.handleConfirmClick}
                onCancel={this.handleCancelClick}
                defaultValue={reply ? reply.text : ''}
              />
            ) : (
              <DisplayBlock text={reply ? reply.text : ''} />
            )}
          </Box>
          <Flex justifyContent="space-between" alignItems="center">
            <Flex>
              <Box mr={1}>
                {isLiked ? (
                  <Icon width={18} height={18} type="lecture-like" />
                ) : (
                  <Icon width={18} height={18} type="lecture-like-o" />
                )}
              </Box>
              <Box>
                <Text.Content onClick={onLike}>{likes} 喜歡</Text.Content>
              </Box>
              {/* <Box>
                <Text.Content onClick={onReply}>回覆</Text.Content>
              </Box> */}
            </Flex>
            <Box>
              {reply ? (
                <Text.ContentGrayLight>
                  {getDuration(moment(reply.ts.toDate()))}
                </Text.ContentGrayLight>
              ) : null}
            </Box>
          </Flex>
        </Flex>
      </ReplyContainer>
    )
  }
}

const mapState = (
  { users, replies, lectureContent }: RootState,
  { replyId }: IConnectProps
) => {
  const reply = replies[replyId] ? replies[replyId] : null
  const replier =
    reply && users[reply.replierId] ? users[reply.replierId] : null
  return {
    reply,
    replier,
    isActive: lectureContent.currentReplyId === replyId
  }
}

const mapDispatch = (dispatch: Dispatch, { replyId }: IConnectProps) => ({
  onFetch: () => dispatch.replies.fetchReplies([replyId])
})

export default connect(
  mapState,
  mapDispatch
)(Reply)



// WEBPACK FOOTER //
// ./src/components/Reply/index.tsx